<template>
    <span class="badge rounded-pill bg-success winner-badge">Winner</span>
</template>

<script>
export default {
    name: "winner-badge",

    props: [],

    mixins: [],

    data: function () {
        return {}
    },


    computed: {},

    methods: {}

}
</script>

<style scoped>
.winner-badge{
     /*badge-color: #396f3a;*/
}
</style>
